import {
  FETCH_ERROR,
} from '../actions/types'

const asyncMiddleware = store => next => async (action) => { // eslint-disable-line
  if (action.payload instanceof Promise) {
    try {
      const response = await action.payload
      const responseJson = response.json instanceof Function ? await response.json() : response
      console.group('reponse status')
      console.warn(response)
      console.group('response data')
      console.warn(responseJson)
      console.groupEnd()
      console.groupEnd()
      const newAction = response.status === 200 ? { type: action.type, data: { ...responseJson, actionType: action.type }, error: false } : { type: action.type, data: responseJson, error: true }
      next(newAction)
    } catch (error) {
      const newAction = { type: FETCH_ERROR, status: FETCH_ERROR, error }
      next(newAction)
    }
  } else {
    next(action)
  }
}

export default asyncMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/asyncMiddleware.js